var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex items-start w-9/12",
      class: _vm.messageContainerPosition,
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col", class: _vm.avatarPosition },
        [
          _c("CircleWithInitials", {
            attrs: {
              avatar: this.data.sender.avatar,
              title: _vm.senderName,
              large: "",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "flex flex-col mx-2" }, [
        !_vm.myself
          ? _c("span", { staticClass: "text-sm font-bold" }, [
              _vm._v(" " + _vm._s(_vm.senderName) + " "),
            ])
          : _vm._e(),
        _vm.data.content
          ? _c(
              "div",
              {
                staticClass: "flex flex-col px-3 py-2",
                class: _vm.messageContainerStyle,
              },
              _vm._l(_vm.messageContent, function (content) {
                return _c("span", { key: content }, [
                  _vm._v(" " + _vm._s(content) + " "),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm.data.attachment
          ? _c(
              "div",
              {
                staticClass:
                  "cursor-pointer my-2 py-1 px-2 flex items-center hover:bg-chatMessage-hover transition duration-300",
                class: _vm.messageContainerStyle,
                on: {
                  click: function ($event) {
                    return _vm.handleDownload(_vm.data.attachment)
                  },
                },
              },
              [
                _vm.uploadingShown
                  ? _c("div", [
                      _c("div", [
                        _c("span", {
                          staticClass: "text-xl mdi mdi-file-document-outline",
                        }),
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(_vm._s(_vm.filename)),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c("Spinner", {
                            staticClass: "mr-2",
                            attrs: { size: "sm" },
                          }),
                          _c("span", { staticClass: "text-sm text-gray-600" }, [
                            _vm._v("Uploading..."),
                          ]),
                        ],
                        1
                      ),
                    ])
                  : _c("div", [
                      _vm.isImage
                        ? _c(
                            "figure",
                            { staticClass: "w-8 h-8 flex-shrink-0" },
                            [
                              _c("img", {
                                staticClass:
                                  "w-full h-full object-cover rounded-md",
                                attrs: { src: _vm.filepath, alt: "User icon" },
                              }),
                            ]
                          )
                        : _c("span", {
                            staticClass:
                              "text-xl mdi mdi-file-document-outline",
                          }),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.filename)),
                      ]),
                    ]),
              ]
            )
          : _vm._e(),
        _c(
          "span",
          {
            staticClass: "mt-1 text-2xs text-gray-400 flex",
            class: _vm.messageDatePosition,
          },
          [_vm._v(" " + _vm._s(_vm.messageDate) + " ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }